module.exports = __webpack_public_path__ + "static/media/24UHCHR2.bbffd788.jpg";